import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { SubSegment } from 'src/app/models/SubSegment';
@Injectable({
    providedIn: 'root'
})
export class SubSegmentApi extends Api<SubSegment> {
}
